import React, { Component } from "react";
import { Card, CardBody, Button, Progress } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import ViewHeader from "../view-header";
import "../index.scss";
import PageEmptyContent from "../../utils/page.empty-content";
import { commonActions, apiActions, alertActions } from "../../../_actions";
import { store } from "../../../_helpers";
import { exchangeRateService } from "../../../_services";
import { appConstants } from "../../../_constants";
import { appHelpers } from "../../../_helpers";
import PageLoading from "../../utils/page.loading";
import PageError from "../../utils/page.error";
import NotificationSystem from "react-notification-system";
import BackIcon from "react-icons/lib/ti/arrow-back";
import DownloadIcon from "react-icons/lib/ti/download";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class RateHistoryDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rateModalOpen: false,
      editingRate: null,
      countries: [],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      records: [],
      status: "",
      countryCode: "",
      CurrencyCode: "",
      startDate: moment().subtract(1, "month").toDate(),
      endDate: new Date(),
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      form: {
        country: "",
        currencyCode: "",
        exchangeRateUsd: "",
        exchangeRateNgn: "",
      },
    };
    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    const { countries } = reduxState;

    if (countries) {
      this.setState({ countries: countries.Results });
    } else {
      this.fetchCountries();
    }
    const navState = this.props.location && this.props.location.state;
    if (navState && (navState.records || navState.histories)) {
      const records = navState.records || navState.histories || [];
      this.setState({ records });
    } else {
      this.search();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.countries !== this.props.countries && this.props.countries) {
      this.setState({ countries: this.props.countries.Results });
    }
  }

  fetchCountries = () => {
    const { dispatch } = this.props;

    dispatch(commonActions.getAllCountries())
      .then(() => {
        const { countries } = store.getState();
        this.setState({ countries: countries ? countries.Results : [] });
        dispatch(apiActions.endRequest());
      })
      .catch(() => {
        dispatch(apiActions.endRequest());
      });
  };

  downloadExcel = () => {};
  downloadPdf = () => {};

  downloadHistory = () => {
    const { dispatch } = this.props;
    const navState = this.props.location && this.props.location.state;
    const currencyCode = (navState && navState.CurrencyCode) ||
      (this.state.records && this.state.records[0] && (this.state.records[0].CurrencyCode || this.state.records[0].currencyCode)) || "";

    dispatch(apiActions.startRequest());

    exchangeRateService
      .downloadHistory(currencyCode)
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const response = res.response;
          const blob = response && response.data ? response.data : response;
          const fileName = `rate-history-${currencyCode || "all"}`;
          // try CSV download first
          appHelpers.downloadFromFilestream(blob, fileName, "text/csv");
        } else {
          const msg = appHelpers.interpretErrorResponse(res.response || res);
          dispatch(alertActions.error(msg));
        }
        dispatch(apiActions.endRequest());
      })
      .catch((err) => {
        const errorMessage = appHelpers.interpretErrorResponse(err);
        dispatch(alertActions.error(errorMessage));
        dispatch(apiActions.endRequest());
      });
  };
  render() {
    const {
      countries,
      records,
      currentPage,
      pageSize,
      totalCount,
      CurrencyCode,
      countryCode,
      status,
      startDate,
      endDate,
      contentError,
    } = this.state;
    const { requesting, pageRequesting } = this.props;
    console.log(records, "records");

    return (
      <div className="view exchange-rate-view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4 exchange-rate-card">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            <div
              className="d-flex align-items-center mb-5 p-2"
              onClick={() => this.props.history.push("/exchange-rate/")}
              style={{ cursor: "pointer" }}
            >
              <BackIcon size={24} className="me-2" />
              <h5 className="mb-0 fw-semibold cursor-pointer">Rate details</h5>
            </div>
            {!contentError && !pageRequesting && (
              <CardBody>
                <div className="d-flex align-items-center justify-content-between">
                  {(() => {
                    const navState =
                      this.props.location && this.props.location.state;
                    const country =
                      (navState && navState.country) ||
                      (records &&
                        records[0] &&
                        (records[0].Country || records[0].country)) ||
                      "";
                    const currencyCode =
                      (navState && navState.CurrencyCode) ||
                      (records &&
                        records[0] &&
                        (records[0].CurrencyCode || records[0].currencyCode)) ||
                      "";
                    const ngn =
                      (navState && navState.NGNExchangeRate) ||
                      (records && records[0] && records[0].NGNExchangeRate) ||
                      null;
                    const statusVal =
                      (navState && navState.Status) ||
                      (records && records[0] && records[0].Status) ||
                      null;
                    const statusLabel =
                      statusVal === 2
                        ? "Active"
                        : statusVal
                          ? "Pending approval"
                          : "";
                    const formattedNgn =
                      ngn !== null && ngn !== undefined
                        ? `N${Number(ngn).toLocaleString()}`
                        : "";

                    return (
                      <div className="p-4 mb-0">
                        <h6 className="mb-3">
                          {country
                            ? `${country}${currencyCode ? ` (${currencyCode})` : ""}`
                            : ""}
                          {country && statusLabel ? " \u00A0" : ""}
                          {statusLabel && (
                            <span
                              className={
                                statusVal === 2
                                  ? "text-success fw-bold ms-2"
                                  : "text-warning fw-bold ms-2"
                              }
                            >
                              {statusLabel}
                            </span>
                          )}
                        </h6>
                        <h6 className="mb-3">{formattedNgn}</h6>
                      </div>
                    );
                  })()}
                  {records && records.length > 0 && (
                    <div>
                      <Button
                        color="secondary"
                        className="mr-2"
                        onClick={this.downloadHistory}
                      >
                        <DownloadIcon size={18} className="me-4" />
                        Download
                      </Button>
                    </div>
                  )}
                </div>
                <CardBody>
                  <h5 className="mb-4 fw-semibold cursor-pointer">
                    Rate history
                  </h5>

                  {records && records.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table exchange-rate-upload-table mb-0">
                        <thead>
                          <tr>
                            <th>Exchange Rate (NGN)</th>
                            <th>Exchange Rate (USD)</th>
                            <th>USD Equivalent of $20</th>
                            <th>Date modified</th>
                            <th>Approver</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records.map(function (record, index) {
                            return (
                              <tr key={index}>
                                <td>{record.NGNExchangeRate}</td>
                                <td>{record.USDExchangeRate}</td>
                                <td>{record.USD20_ROE}</td>
                                <td>
                                  {moment(record.UpdatedDate).format(
                                    "MMM Do YYYY",
                                  )}
                                </td>
                                <td>{record.ApprovedBy}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <PageEmptyContent message="No exchange rates available" />
                  )}
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { requesting, pageRequesting } = state.api;
  const { countries } = state;

  return {
    requesting,
    pageRequesting,
    countries,
  };
}

export default connect(mapStateToProps)(RateHistoryDetails);



// WEBPACK FOOTER //
// ./src/views/exchange-rate/RateHistoryDetails/rate-history-details.js